import React, { useContext, useState, useEffect } from "react";

import { RefinementList } from "react-instantsearch-dom";

import {
  SpecificLocationRefinement,
  CollapsibleCustomPanel,
  CollapsiblePanel,
} from "components/SearchFilters/components";
import GeographicalRegion from "components/SearchFilters/components/GeographicalRegion";

import { JobsContext, SearchContext } from "context/providers";
import { cn } from "utils";

const LOCATION_FILTER_TYPES = {
  SPECIFIC: "SPECIFIC",
  COUNTRY: "COUNTRY",
};

const DEFAULT_COUNTRY_LIMIT = 5;
// High enough to render every country a region can select, since the list is
// narrowed down to the selected ones while a region is active.
const SELECTED_ONLY_COUNTRY_LIMIT = 500;

// Facet values coming from the "Find a country" search carry a highlight
// payload; browsed values do not. Keep search results untouched so typing an
// unselected country can still find it.
const hideUnselectedCountries = (items) =>
  items.some((item) => item._highlightResult)
    ? items
    : items.filter((item) => item.isRefined);

const LocationFiltersWrapper = () => {
  const [locationFilterType, setLocationFilterType] = useState(
    LOCATION_FILTER_TYPES.COUNTRY
  );

  const {
    searchState,
    geographicalRegions,
    setGeographicalRegions,
    clearLocationFilters,
  } = useContext(SearchContext);

  const { jobOpp } = useContext(JobsContext);

  const hasActiveRegion = geographicalRegions.some(
    (geoRegion) => geoRegion.checked
  );

  useEffect(() => {
    if (jobOpp?.id && jobOpp.location) {
      setLocationFilterType(LOCATION_FILTER_TYPES.SPECIFIC);
    } else {
      setLocationFilterType(LOCATION_FILTER_TYPES.COUNTRY);
    }
  }, [jobOpp]);

  return (
    <div>
      <CollapsibleCustomPanel
        id="filter-group-location-country"
        title="Location"
        sectionKey="location-country"
        defaultCollapsed={true}
        checked={locationFilterType === LOCATION_FILTER_TYPES.SPECIFIC}
        toggle
        leftToggleLabel="REGION"
        rightToggleLabel={LOCATION_FILTER_TYPES.SPECIFIC}
        onChange={(value) => {
          clearLocationFilters();
          if (value) {
            setLocationFilterType(LOCATION_FILTER_TYPES.SPECIFIC);
          } else {
            setLocationFilterType(LOCATION_FILTER_TYPES.COUNTRY);
          }
        }}
      >
        <div
          className={cn({
            hidden: locationFilterType !== LOCATION_FILTER_TYPES.SPECIFIC,
          })}
        >
          <SpecificLocationRefinement />
        </div>

        <div
          className={cn({
            hidden: locationFilterType !== LOCATION_FILTER_TYPES.COUNTRY,
          })}
        >
          <RefinementList
            attribute="location.countryName"
            translations={{
              placeholder: "Find a country",
            }}
            limit={
              hasActiveRegion
                ? SELECTED_ONLY_COUNTRY_LIMIT
                : DEFAULT_COUNTRY_LIMIT
            }
            searchable
            showMore={!hasActiveRegion}
            transformItems={
              hasActiveRegion ? hideUnselectedCountries : undefined
            }
          />
        </div>
      </CollapsibleCustomPanel>

      <div
        className={cn({
          hidden: locationFilterType !== LOCATION_FILTER_TYPES.COUNTRY,
        })}
        id="filter-group-location-region"
      >
        <CollapsiblePanel
          header="Location (Region)"
          sectionKey="location-region"
          defaultCollapsed={true}
        >
          <GeographicalRegion
            geographicalRegions={geographicalRegions}
            searchState={searchState}
            setGeographicalRegions={setGeographicalRegions}
          />
        </CollapsiblePanel>
      </div>
    </div>
  );
};

export default LocationFiltersWrapper;
